import C from '../actions/constants'

export const unitConverter = (state = {}, action) => {
    switch (action.type) {
        case C.SET_UNIT_CONVERTER_VALUES:
            return { ...state, ...action.payload }
        default:
            return state
    }
}